"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.sortedVirtualSlotsByTime = exports.shouldUseJumpToDate = exports.shouldShowRegulatedSpacesBanner = exports.formatTimeForErrorMsg = exports.batchAppointmentsByDay = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _moment = _interopRequireDefault(require("moment"));
const batchAppointmentsByDay = (appointments, filterBy) => {
  var _context, _context2;
  const batch = {};
  const isFilteredByTime = filterBy.timeOfDay.size > 0;
  const isFilteredByDay = filterBy.dayOfWeek.size > 0;
  (0, _forEach.default)(appointments).call(appointments, appt => {
    const dateKey = (0, _moment.default)(appt.start_datetime).format('YYYY-MM-DD');
    const locKey = appt.location_id;
    if (isFilteredByTime && !filterBy.timeOfDay.has(appt.time_of_day) || isFilteredByDay && !filterBy.dayOfWeek.has(appt.day_of_week)) {
      return;
    }
    if (!batch[dateKey]) {
      batch[dateKey] = {};
    }
    if (!batch[dateKey][locKey]) {
      batch[dateKey][locKey] = [];
    }
    batch[dateKey][locKey].push(appt);
  });
  const sorted = (0, _sort.default)(_context = (0, _map.default)(_context2 = (0, _keys.default)(batch)).call(_context2, header => ({
    header,
    byLocId: batch[header]
  }))).call(_context, (a, b) => {
    return (0, _moment.default)(a.header).valueOf() - (0, _moment.default)(b.header).valueOf();
  });
  return sorted;
};
exports.batchAppointmentsByDay = batchAppointmentsByDay;
const sortedVirtualSlotsByTime = groupByLocId => {
  var _context3;
  const groupedData = [];
  (0, _map.default)(_context3 = (0, _keys.default)(groupByLocId)).call(_context3, item => {
    var _context4;
    (0, _map.default)(_context4 = groupByLocId[item]).call(_context4, items => {
      groupedData.push(items);
    });
  });
  const sorted = (0, _sort.default)(groupedData).call(groupedData, (a, b) => {
    return (0, _moment.default)(a.start_datetime).valueOf() - (0, _moment.default)(b.start_datetime).valueOf();
  });
  return sorted;
};
exports.sortedVirtualSlotsByTime = sortedVirtualSlotsByTime;
const formatTimeForErrorMsg = slotTime => (0, _moment.default)(slotTime).format('ddd, MMM DD - h:mm A');

/** Darkship feature flag for new "Jump to date" filter bar. See: https://kyruus.jira.com/browse/KENG-33104 */
exports.formatTimeForErrorMsg = formatTimeForErrorMsg;
const shouldUseJumpToDate = config => !!config?.darkship_use_jump_to_date;

/** Feature flag to enable `Regulated Spaces` */
exports.shouldUseJumpToDate = shouldUseJumpToDate;
const shouldShowRegulatedSpacesBanner = config => !!config?.show_regulated_spaces_banner;
exports.shouldShowRegulatedSpacesBanner = shouldShowRegulatedSpacesBanner;